import Chip from 'components/@extended/Chip';
import { Link as LinkIcon } from 'components/icons';

const TimecardLinkIcon = (): JSX.Element => (
    <Chip
        size="small"
        className="bg-link/7 text-link rounded-sm px-1 [&_svg]:size-4"
        label={<LinkIcon className="rotate-45 cursor-pointer" />}
    />
);

export default TimecardLinkIcon;
